import FormOTPAndPIN from "@components/inputs/FormOTPAndPIN";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { ForgotSecretCallbackProps } from "@components/utils/Auth/types/auth-props";
import { OnboardMode } from "@constants";
import { useOnboardingPhone } from "@hooks/useOnboardingPhone";

interface ForgotSecretPPProps extends ForgotSecretCallbackProps {
  defaultPhone?: string;
}

const ForgotSecretPP = ({
  defaultPhone,
  onLoginSuccess,
  onForgotSecretSuccess,
  onPostLoginCheckPassed,
  onPostLoginCheckFailed,
}: ForgotSecretPPProps) => {
  const { phone } = useOnboardingPhone();
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
    onPostLoginCheckPassed,
    onPostLoginCheckFailed,
  });

  return (
    <FormOTPAndPIN
      phone={defaultPhone ?? phone}
      mode={OnboardMode.LOGIN}
      onLoginSuccess={postLoginCheck}
      onUpdatePINSuccess={onForgotSecretSuccess}
      otpMode="forgot-password"
    />
  );
};

export default ForgotSecretPP;
